import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import focalPointApiClient from 'Services/Apis/FocalPoint/conciergeApiClient';

export const getListManagePointsThunk = createAsyncThunk(
    `GetListManagePointsSlicer/getListManagePointsThunk`,
    async ({ filter, pageSize, currentPage, desc, deadline }, { getState }) => {
        const { user } = getState().oidc;
        const headers = {
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            Authorization: `Bearer ${user.access_token}`,
        };

        var params = new URLSearchParams();

        if (filter)
            params.append("filter", filter);

        params.append("pageSize", pageSize);
        params.append("currentPage", currentPage);

        params.append('desc', desc);

        if (deadline)
            params.append('deadline', deadline);

        const { data } = await focalPointApiClient.get(
            `DistributionAvailableAndHistory/list-distribution-available-and-history`,
            {
                params,
                headers,
            });
        return data;
    }
);

const initialState = {
    dataGetListManagePoints: [],
    loadingGetListManagePoints: false,
    errorGetListManagePoints: false,
};

const GetListManagePointsSlicer = createSlice({
    name: 'GetListManagePoints',
    initialState,
    reducers: {
        resetDataGetListManagePoints: (state) => {
            state.dataGetListManagePoints = [];
            state.loadingGetListManagePoints = false;
            state.errorGetListManagePoints = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getListManagePointsThunk.pending, (state) => {
            state.dataGetListManagePoints = [];
            state.loadingGetListManagePoints = true;
            state.errorGetListManagePoints = false;
        });
        builder.addCase(getListManagePointsThunk.fulfilled, (state, action) => {
            state.dataGetListManagePoints = action.payload;
            state.loadingGetListManagePoints = false;
            state.errorGetListManagePoints = false;
        });
        builder.addCase(getListManagePointsThunk.rejected, (state) => {
            state.dataGetListManagePoints = [];
            state.loadingGetListManagePoints = false;
            state.errorGetListManagePoints = true;
        });
    },
});

export const { resetDataGetListManagePoints } = GetListManagePointsSlicer.actions;
export default GetListManagePointsSlicer.reducer;